import React from "react";
import { useLocation } from "react-router-dom";
import Button from '@mui/material/Button';
import "./DirectPayment.scss";

const DirectPaymentFailure = () => {
    const location = useLocation();
    const id = location.search ? location.search.substring(1) : null;

    const handleRetry = () => {
        if (id) {
            window.location.href = `/order/pay?${id}`;
        }
    };

    return (
        <div className="direct-payment">
            <div className="direct-payment-container">
                <div className="result-message failure">
                    <i className="fas fa-times-circle fa-3x"></i>
                    <h2>Paiement échoué</h2>
                    <p>Votre paiement n'a pas pu être effectué.</p>
                    <p>Veuillez vérifier vos informations de carte et réessayer.</p>

                    {id && (
                        <Button
                            style={{fontSize: '16px', marginTop: '20px'}}
                            variant="contained"
                            onClick={handleRetry}
                        >
                            Réessayer le paiement
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DirectPaymentFailure;
